/**
 * Created by tayloremolo on 11/4/17.
 */
import React, {Component} from 'react';
import ReactDOM from "react-dom";
import CTA from "../components/cta";

class SectionSix extends Component {
    // constructor() {
    //     super();
    //
    // }
    // componentDidMount(){
    //     });
    // }

    render() {

        return (
            <div>
                <div className="section-3-et section -six e4-bg  block-4 z-15">
                    <div className="container relative-text p-20">
                        <div className="row m0 valign-wrapper hide-on-med-and-down">

                            <div className="col s12 m5">
                                <img className="img-sticky responsive-img relative-text" src="../static/rhett.png" alt="Anthony Delgado"/>
                            </div>
                            <div className="col s12 m7 center-align">
                                <p className="f-38 --brand-shadow brand-text text-normal right-align mobile-center text-uppercase mb0">BLOCKCHAIN EXPERT</p>
                                <h1 className="f-62 white-text bold-text text-uppercase right-align mobile-center mb0 --brand-shadow">RHETT<br/><span className="f-100 ls-5 white-text">CREIGHTON</span></h1>
                                <p className="f-18 white-text right-align mobile-center">
                                    <span className="f-26 bold-text text-uppercase ls-3">Blockchain Day</span> is an exclusive, all day networking event focused on the business and technology of tokenization. Attendees will gain a wealth of insights and information about the state of the token-based economy while networking with senior level decision makers.</p>
                                <div className="col s12 right-align mobile-center p0">
                                    <CTA/>
                                    <br/>
                                </div>
                            </div>
                        </div>


                        {/*MOBILE VERSION*/}
                        <div className="row m0 hide-on-large-only">
                            <div className="col s12 center-align">
                                <p className="f-26 white-text mobile-center text-uppercase mb0">Founder & Leader</p>
                                <h1 className="f-62 white-text bold-text text-uppercase mobile-center mb0 --brand-shadow">Anthony<br/><span className="f-100 ls-5 white-text">Delgado</span> </h1>
                                <p className="f-18 white-text mobile-center">“Coding is a skill that can transform lives. We feel that by teaching digital skills on the island of Puerto Rico we can empower the new generation of thought leaders, developers, creators, digital marketers and entrepreneurs, to build new businesses, grow their careers, chase their passions and create financial freedom for themselves, their families, and their future generations. We are part of a global movement to increase diversity in tech and grow new economies in under served communities around the world.”</p>
                                <p className="f-18 white-text right-align mobile-center">We are part of a global movement to increase diversity in tech and grow new economies in under served communities around the  <span className="f-26 bold-text text-uppercase ls-3">WORLD.</span></p>
                                <div className="col s12 center-align p0">
                                    <CTA/>
                                    <br/>
                                </div>
                            </div>
                            <div className="col s12 m10 offset-m1">
                                <img className="img-sticky responsive-img relative-text" src="../static/anthony-cutout.png" alt="Anthony Delgado"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )

    }

}

export default SectionSix;


// WEBPACK FOOTER //
// ./src/components/section-six.js